import { CardArray } from './card.array'
import { GameProps, gamePropsNull } from './game.props'
import { GamePlayGameId } from './game-play-game-id'
import { Card } from './card'

export abstract class Game {
  public readonly gamePlayId = this.gameProps.gamePlayId
  public readonly gameId = this.gameProps.gameId
  public readonly user = this.gameProps.user
  public readonly rightOpponent = this.gameProps.rightOpponent
  public readonly leftOpponent = this.gameProps.leftOpponent

  public readonly shouldShowTalonCardsOnTable =
    this.gameProps.shouldShowTalonCardsOnTable

  public readonly shouldShowTalonCardsInGameInfo =
    this.gameProps.shouldShowTalonCardsInGameInfo

  public readonly isContractDeclared = this.gameProps.isContractDeclared

  public readonly shouldShowTalonCardsOnTableFaceUp =
    this.gameProps.shouldShowTalonCardsOnTableFaceUp

  protected talonCards = this.gameProps.talonCards

  public getTalonCards(): Card[] {
    return CardArray.from(this.talonCards).sortCards()
  }

  public readonly discardedCards = CardArray.from(
    this.gameProps.discardedCards,
  ).sortCards()

  public readonly contract = this.gameProps.contract
  public readonly gameStatus = this.gameProps.gameStatus

  public readonly shouldShowDeclaredDefendOptions =
    this.gameProps.shouldShowDeclaredDefendOptions

  public readonly doublingCountRoundsLeftToQueue =
    this.gameProps.doublingCountRoundsLeftToQueue

  public readonly doublingCountRoundsQueued =
    this.gameProps.doublingCountRoundsQueued

  public readonly isDoublingCountRound = this.gameProps.isDoublingCountRound

  public readonly shouldShowContractSection =
    this.gameProps.shouldShowContractSection

  public readonly players = [this.user, this.rightOpponent, this.leftOpponent]

  public readonly gamePlayGameId: GamePlayGameId = {
    gamePlayId: this.gamePlayId,
    gameId: this.gameId,
  }

  public readonly shouldShowPreviousTrick =
    this.gameProps.shouldShowPreviousTrick

  public readonly shouldShowBiddingSection =
    this.gameProps.shouldShowBiddingSection

  public readonly shouldShowUserActions = this.gameProps.shouldShowUserActions
  public readonly isTalonCardsSelectable = this.gameProps.isTalonCardsSelectable
  public readonly shouldPoll = this.gameProps.shouldPoll
  public readonly highlightedCards = this.gameProps.highlightedCards

  public readonly shouldShowPassFailStatus =
    this.gameProps.shouldShowPassFailStatus

  protected constructor(private gameProps: GameProps) {}

  public getDeclarerUsername(): string {
    const declarer = this.players.find((player) => player.hasDeclaredContract)
    return declarer?.username ?? ''
  }

  public getIsUserCardsSelectable(): boolean {
    return this.gameProps.isUserCardsSelectable
  }
}

class GameNull extends Game {
  public constructor() {
    super(gamePropsNull)
  }
}

export const gameNull: Game = new GameNull()
